import React, { Component } from "react";
import { connect } from "react-redux";
import { Panel } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import _ from "lodash";
import moment from "moment";
import Plot from "react-plotly.js";
import { Link } from "react-router-dom";
import { api } from "../../_services";

import "./index.css";

class DashboardActionCount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listLoading: true,
      listLoading2: true,
      color: {
        1: "#7552DE",
        2: "#2196F3",
        3: "#09D08A",
      }
    };
  }

  componentDidMount = () => {
    if (this.props.currentPrecinct) {
      if (this.props.currentPrecinct.id !== 0) {
        this.getActionCounts({ "precinct": this.props.currentPrecinct.id });
      } else {
        this.getActionCounts({});
      }
    }
    const configList = this.props.configList;
    if (configList && configList.precincts) {
      this.setState({
        precincts: configList.precincts,
      });
    }
    if (configList && configList.permissions.notes[0].disciplines) {
      this.setState({
        disciplines: configList.permissions.notes[0].disciplines,
      });
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.currentPrecinct !== nextProps.currentPrecinct && nextProps.currentPrecinct) {
      if (nextProps.currentPrecinct.id !== 0) {
        this.getActionCounts({ "precinct": nextProps.currentPrecinct.id });
      } else {
        this.getActionCounts({});
      }
    } else if (this.props.reloadCount !== nextProps.reloadCount) {
      if (this.props.currentPrecinct.id !== 0) {
        this.getActionCounts({ "precinct": nextProps.currentPrecinct.id });
      } else {
        this.getActionCounts({});
      }
    }
  }

  /* Retrieve action count by precincts */
  getActionCounts = p => {
    this.setState(() => {
      return {
        listLoading2: true,
      };
    });
    const url = "/api/v1/stats/alerts/";
    const token = this.props.user.token;
    const params = {};
    if (p) {
      for (const key in p) {
        params[key] = p[key];
      }
    }
    const errorMsg = "Unable to retrieve action count.";
    params.period_start = moment().subtract(1, "d").format();
    params.comparison_period_start = moment().subtract(2, "d").format();
    params.comparison_period_end = moment().subtract(1, "d").format();
    api.getFetch(url, params, token, errorMsg).then(json => {
      this.setState(() => {
        return {
          chartDataDay: json,
        };
      });
    }).then(() => {
      params.period_start = moment().subtract(7, "d").format();
      params.comparison_period_start = moment().subtract(14, "d").format();
      params.comparison_period_end = moment().subtract(7, "d").format();
      api.getFetch(url, params, token, errorMsg).then(json => {
        this.setState(() => {
          return {
            chartDataWeek: json,
            listLoading: false,
            listLoading2: false,
          };
        });
      });
    });
  };

  convertData = (data) => {
    const chartData = {};
    const { precincts, disciplines, color } = this.state;
    const { currentPrecinct } = this.props;
    precincts.forEach(function (precinct) {
      if (data[precinct.id] !== undefined) {
        disciplines.forEach(function (discipline) {
          if (!chartData[discipline.id]) {
            chartData[discipline.id] = {};
          }
          if (data[precinct.id][discipline.id] !== undefined) {
            chartData[discipline.id][precinct.id] = data[precinct.id][discipline.id];
          }
        });
      }
    });
    const converted = [];
    disciplines.forEach(function (discipline) {
      const disciplinePrecincts = [];
      precincts.forEach(function (precinct) {
        if (currentPrecinct.id === 0 || currentPrecinct.id === precinct.id) {
          disciplinePrecincts.push({
            id: precinct.id,
            name: precinct.name,
            value: chartData[discipline.id][precinct.id],
          });
        }
      });
      const arrayValue = _.map(_.uniqBy(disciplinePrecincts, "id"), "value");
      const arrayName = _.map(_.uniqBy(disciplinePrecincts, "id"), "name");
      converted.push({
        x: arrayName,
        y: arrayValue,
        name: discipline.name,
        type: "bar",
        marker: { color: color[discipline.id] },
      });
    });
    return converted;
  }

  renderMovementIndicator = (val, oldVal) => {

    const percentDiff = ((oldVal - val) / oldVal) * 100;
    let percentDiffDisplay = Math.round(percentDiff * 100) / 100;
    if (percentDiffDisplay < 0) {
      percentDiffDisplay = Math.abs(percentDiffDisplay);
    }
    const diff = val - oldVal;
    if (!isFinite(percentDiff) && percentDiff < -30) {
      return (
        <div className="movement-indicator movement-indicator-up-critical">
          <span>&#x25B2;</span> {(diff > 0 ? "+" : "") + diff}
        </div>
      );
    } else if (percentDiff < -30) {
      return (
        <div className="movement-indicator movement-indicator-up-critical">
          <span>&#x25B2;</span> {(diff > 0 ? "+" : "") + diff} (+{percentDiffDisplay}%)
        </div>
      );
    } else if (percentDiff < -10) {
      return (
        <div className="movement-indicator movement-indicator-up-warning">
          <span>&#x25B2;</span> {(diff > 0 ? "+" : "") + diff} (+{percentDiffDisplay}%)
        </div>
      );
    } else if (percentDiff < 0) {
      return (
        <div className="movement-indicator movement-indicator-up">
          <span>&#x25B2;</span> {(diff > 0 ? "+" : "") + diff} (+{percentDiffDisplay}%)
        </div>
      );
    } else if (percentDiff === 0) {
      return (
        <div className="movement-indicator movement-indicator-neutral">
          <span>&#x25FC;</span> --
        </div>
      );
    } else if (percentDiff > 0) {
      return (
        <div className="movement-indicator movement-indicator-down">
          <span>&#x25BC;</span> {(diff > 0 ? "+" : "") + diff} (-{percentDiffDisplay}%)
        </div>
      );
    } else {
      return (
        <div className="movement-indicator movement-indicator-neutral">
          <span>&#x25FC;</span> --
        </div>
      );
    }
  }

  renderDisciplines = (data, indicatorText) => {
    if (data && data.within_period.alert_counts_by_discipline) {
      const alertCount = data.within_period.alert_counts_by_discipline;
      const alertCountComparison = data.within_comparison_period.alert_counts_by_discipline;
      const alertCountList = [];
      const precinctsLink = (this.props.currentPrecinct && this.props.currentPrecinct.id) ? "&precincts=" + this.props.currentPrecinct.id : "";
      this.state.disciplines.forEach(function (discipline) {
        if (alertCount[discipline.id] !== undefined) {
          alertCountList.push({
            id: discipline.id,
            name: discipline.name,
            value: alertCount[discipline.id]
          });
        }
      });
      return (
        alertCountList.map(function (item, index) {
          return (
            <div className="flex-col" key={index}>
              <Link to={"/alerts?disciplines=" + item.id + "&start_time=" + encodeURIComponent(moment(data.period_start).toISOString()) + precinctsLink} title={item.name} className="actionCountLink">
                <div className="subTitle">{item.name}</div>
                <div className="valueCon">
                  {item.value}
                  <div title={indicatorText}>
                    {this.renderMovementIndicator(item.value, alertCountComparison[item.id])}
                  </div>
                </div>
              </Link>
            </div>
          );
        }, this)
      );
    } else {
      return null;
    }
  }

  getMaxNumber = (alertCount) => {
    let maxNumber = 10;
    // loop throught each precinct object to get the each discipline sum up and return the number if it's over 10.
    _.forOwn(alertCount, function (alerts) {
      let totalAlert = 0;
      _.forOwn(alerts, function (alert) {
        totalAlert = totalAlert + alert;
      });
      if (totalAlert > maxNumber) {
        maxNumber = totalAlert;
      }
    });
    return maxNumber;
  }

  renderChart = (data) => {
    if (data && data.within_period.alert_counts_by_precinct_and_discipline) {
      const alertCount = data.within_period.alert_counts_by_precinct_and_discipline;

      const maxNumber = this.getMaxNumber(alertCount);
      const convertedData = this.convertData(alertCount);
      const chartConfig = {
        displaylogo: false,
        modeBarButtonsToRemove: [
          "zoom2d", "pan2d", "select2d", "lasso2d", "zoomIn2d", "zoomOut2d", "autoScale2d", "resetScale2d",
          "hoverClosestCartesian", "hoverCompareCartesian",
          "zoom3d", "pan3d", "resetCameraDefault3d", "resetCameraLastSave3d", "hoverClosest3d",
          "orbitRotation", "tableRotation",
          "zoomInGeo", "zoomOutGeo", "resetGeo", "hoverClosestGeo",
          "toImage",
          "sendDataToCloud",
          "hoverClosestGl2d",
          "hoverClosestPie",
          "toggleHover",
          "resetViews",
          "toggleSpikelines",
          "resetViewMapbox"
        ]
      };
      const chartLayout = {
        autosize: true,
        showlegend: true,
        margin: {
          l: 25,
          r: 20,
          b: 50,
          t: 10,
          pad: 8
        },
        barmode: "stack",
        xaxis: {
          tickfont: {
            size: 8
          }
        },
        yaxis: {
          tickfont: {
            size: 8
          },
          range: [0, maxNumber]
        },
        legend: {
          orientation: "h",
          font: {
            size: 8,
          },
          y: 1.2,
        },
      };
      return (
        <Plot
          className="chartDiagram"
          data={convertedData}
          layout={chartLayout}
          config={chartConfig}
          useResizeHandler={true}
        />
      );
    } else {
      return (
        <div className="chartDiagram emptyCon">No data</div>
      );
    }
  }

  render() {

    const { configList, toggleFunction } = this.props;
    const {
      chartDataDay,
      chartDataWeek,
      listLoading,
      listLoading2,
    } = this.state;

    if (!configList) {
      return null;
    }

    if (listLoading) {
      return (
        <Panel className="panel-length actionCount">
          <div className="loading2" />
        </Panel>
      );
    }

    return (
      <Panel className="panel-length actionCount">
        <div className="panel-title">
          Reportable Alerts {listLoading2 && <FontAwesome className="loadingIcon" name="spinner" spin />}
          <a className="pull-right btn btn-primary" onClick={() => toggleFunction()}><FontAwesome name="map" /></a>
        </div>
        <div className="panel-body">
          <div className="flex-row spareRow">
            <div className="flex-col">
              <div className="title">Last 24 hours</div>
              <div className="margin-btm flex-row">
                {this.renderDisciplines(chartDataDay, "compared to previous 24 hour period")}
              </div>
              <div>
                <div>Alert count by discipline</div>
                {this.renderChart(chartDataDay)}
              </div>
            </div>
            <div className="flex-col">
              <div className="title">Last week</div>
              <div className="margin-btm flex-row">
                {this.renderDisciplines(chartDataWeek, "compared to previous 7 day period")}
              </div>
              <div>Alert count by discipline</div>
              <div>
                {this.renderChart(chartDataWeek)}
              </div>
            </div>
          </div>
        </div>
      </Panel >
    );
  }
}

function mapStateToProps(state) {
  const { configList } = state.configuration;
  const { user } = state.authentication;
  return {
    configList,
    user,
  };
}

export default connect(mapStateToProps)(DashboardActionCount);



// WEBPACK FOOTER //
// ./src/_components/DashboardActionCount/index.js